import { render, staticRenderFns } from "./PayrollPreviewDetail.vue?vue&type=template&id=60b182b5"
import script from "./PayrollPreviewDetail.vue?vue&type=script&lang=js"
export * from "./PayrollPreviewDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports